import * as type from "../types";
import {convertLngToLon} from '../../utils/helpers';
import {defaultCenter} from '../../components/MapComponents/MapComponent';

const initialDefaultEmailsAndPhones = {
    email: [],
    telefon: []
};

const initialNotifications = {
    przekroczenie_granicy: {email: false, telefon: false},
    nieautoryzowane_wlaczenie: {email: false, telefon: false},
    postoj: {email: false, telefon: false},
    przelozenie_urzadzenia: {email: false, telefon: false},
    rejonizacja: {email: false, telefon: false},
    rejonizacja_pool: {email: false, telefon: false},
    rozlaczenia: {email: false, telefon: false},
    spuszczenie: {email: false, telefon: false},
    predkosc: {email: false, telefon: false},
    rezerwa: {email: false, telefon: false},
};

const initialReminders = {
    dlugi_postoj: {przypomnienie1: "", przypomnienie2: ""},
    przeglad_techniczny: {przypomnienie1: "", przypomnienie2: ""},
    ubezpieczenie: {przypomnienie1: "", przypomnienie2: ""},
};

const initialOtherSettings = {
    auto_nr_umowy: false,
    wspolni_klienci: false,
    wymagany_nr_zlecenia: false,
    ewidencja_zerowe_dyst: false,
    ewidencja_dodatkowe_kol: false,
    auto_dzielenie_pool: false,
    auto_dzielenie_pool_czas: "",
    czas_rozlaczen_pow: ""
};

const initialMobileAppKey = {
    grupa_id: "",
    klucz_mobilny: ""
};

const initialTrophySettings = {
    trofea: false,
};

const initialTireChange = {
    przypomnienie1: {aktywne: false, dzien: "", miesiac: ""},
    przypomnienie2: {aktywne: false, dzien: "", miesiac: ""},
    przypomnienie3: {aktywne: false, dzien: "", miesiac: ""},
    przypomnienie4: {aktywne: false, dzien: "", miesiac: ""},
};

const initialWorkingHours = {
    godzina_start: 0,
    godzina_koniec: 0,
    poniedzialek: false,
    wtorek: false,
    sroda: false,
    czwartek: false,
    piatek: false,
    sobota: false,
    niedziela: false
};

const initialState = {
    defaultEmailsAndPhones: initialDefaultEmailsAndPhones,
    notifications: initialNotifications,
    reminders: initialReminders,
    otherSettings: initialOtherSettings,
    mobileAppKey: initialMobileAppKey,
    tireChange: initialTireChange,
    regularHolidays: [],
    movingHolidays: [],
    daysOff: [],
    workingHours: initialWorkingHours,
    poiLocations: [],
    poiCoords: convertLngToLon(defaultCenter),
    trophySettings: initialTrophySettings,
    readyToSave: {
        defaultEmailsAndPhones: false,
        notifications: false,
        reminders: false,
        otherSettings: false,
        changePassword: false,
        tireChange: false
    },
    workingHoursReadyToSave: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case type.SET_DEFAULT_EMAILS_AND_PHONES:
            return {
                ...state,
                defaultEmailsAndPhones: action.value
            };
        case type.SET_SETTINGS_NOTIFICATIONS:
            return {
                ...state,
                notifications: action.value
            };
        case type.SET_SETTINGS_REMINDERS:
            return {
                ...state,
                reminders: action.value
            };
        case type.SET_OTHER_SETTINGS:
            return {
                ...state,
                otherSettings: action.value
            };
        case type.SET_SETTINGS_MOBILE_APP_KEY:
            return {
                ...state,
                mobileAppKey: action.value
            };
        case type.SET_SETTINGS_TIRES_CHANGE:
            return {
                ...state,
                tireChange: action.value
            };
        case type.SET_SETTINGS_REGULAR_HOLIDAYS:
            return {
                ...state,
                regularHolidays: action.value
            };
        case type.SET_SETTINGS_MOVING_HOLIDAYS:
            return {
                ...state,
                movingHolidays: action.value
            };
        case type.SET_SETTINGS_DAYS_OFF:
            return {
                ...state,
                daysOff: action.value
            };
        case type.SET_SETTINGS_WORKING_HOURS:
            return {
                ...state,
                workingHours: action.value
            };
        case type.SET_SETTINGS_POI_POINTS:
            return {
                ...state,
                poiLocations: action.value
            };
        case type.SET_SETTINGS_POI_COORDS:
            return {
                ...state,
                poiCoords: action.value
            };
        case type.SET_SETTINGS_TROPHY:
            return {
                ...state,
                trophySettings: action.value
            };
        case type.UPDATE_POI:
            return {
                ...state,
                poiLocations: state.poiLocations.map(poi => {
                    if (poi.poi_id === action.value.poi_id)
                        return action.value;
                    return poi;
                })
            };
        case type.CHANGE_SAVE_READINESS:
            return {
                ...state,
                readyToSave: action.value
            };
        default:
            return state;
    }
};
